import service from '@/utils/server';
const modName='/pda/apk/';
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post'
    })
};

//导入方法
export const pdaUpLoad = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'deployment',
    method: 'post',
    data
  });
};

/**
 * 图片上传
 */
export const uploadUrl = process.env.BASE_URL + '/common/web/deployment' + '/deployment';



// WEBPACK FOOTER //
// ./src/page/sm/pda/api/index.js